<template>
<div class="hot-play">
    <div class="blk-title">看看大家去哪玩</div>
    <div class="list-box">
        <ul class="list">
            <li v-for="(item,index) in list " :key="index">
                <a :href="item.url" target="_blank" class="cover-img"><div class="img-box"><img :src="item.img" alt=""></div></a>
                <a :href="item.url" target="" class="title">{{item.title}}</a>
            </li>
        </ul>
    </div>
</div>
</template>
<script>
export default {
    name:'HotPlay',
    data(){
        return {
            list :[
                {
                    title:'多伦多水上乐园大盘点',
                    url:'https://news.yorkbbs.ca/specials/subject/396413b2-310b-4ecb-9ced-b8bba75f9c13',
                    img:'https://media3.imgyb.xyz/media/v1/image/e504608b15e61b5a6b7726b76ea64b89.jpeg',
                },
                {
                    title:'2023多伦多采摘草莓攻略',
                    url:'https://news.yorkbbs.ca/specials/subject/839490c6-7040-44a3-a4b0-c881602597a3',
                    img:'https://media5.imgyb.xyz/media/v1/image/8c342be13c888dd8ac2e8c3c28a93323.jpeg',
                },
                {
                    title:'多伦多周边室内水上主题乐园',
                    url:'https://news.yorkbbs.ca/detail/events/4cbb5945-b37b-42d0-b539-7b887177e13e',
                    img:'https://media6.imgyb.xyz/media/v1/image/cb5b0643ef5998d9acec269fc8c21d6d.jpeg',
                },
                {
                    title:'7月Cineplex $2.99电影公布啦!',
                    url:'https://news.yorkbbs.ca/detail/deals/1c1c33dc-abb5-4dd3-b540-391a678b3edb',
                    img:'https://media6.imgyb.xyz/media/v1/image/326ef6f75f92bc9f4209cdf5aba73f5a.jpeg',
                },
                {
                    title:'夏日自驾游：安省13个超美的自然奇观！',
                    url:'https://news.yorkbbs.ca/detail/travel/86942a82-4dfd-4d0e-a0f8-b8849b486fb4',
                    img:'https://media2.imgyb.xyz/media/v1/image/59d8b73f60e66c1bf55ee2f20a5558a5.jpeg',
                },
                {
                    title:'多伦多每周周末好去处',
                    url:'https://info.yorkbbs.ca/special/big/865701de-2ceb-4341-bb39-f11bfe9c66d4',
                    img:'https://media4.imgyb.xyz/media/v1/image/cab4d86dc5f3979588a23831100c1a33.jpeg',
                },
            ]
        }
    }
}
</script>
<style lang="less" scoped>
.hot-play{
    margin-top: 30px;
    .blk-title{

        font-size: 26px; text-align: center; margin-bottom: 20px ;
    }
    .list-box{
        background: #fff; border-radius: 4px; padding: 20px 20px 0;
        ul{
            display: flex; flex-wrap: wrap; margin: 0 -15px;
            li{
                width: 33.33%; padding: 0 15px; box-sizing: border-box; margin-bottom: 30px;
                a{
                    display: block;
                    position: relative;
                }
                .img-box{
                    position: relative; padding-bottom: 62.5%; overflow: hidden; border-radius: 4px;
                    img{
                        position: absolute; left: 0;  top: 0; width: 100%; height: 100%; object-fit: cover; transition: all 200ms linear;
                    }
                    &:hover{
                        img{transform: scale(1.2); }
                    }
                }
                .title{
                    font-size: 16px; line-height: 26px; color: #111; margin-top: 15px;
                    &:hover{color: #e43a3a;}
                }
            }
        }
    }
}
@media screen and (max-width:768px){
    .hot-play{
        margin-top: 20px;
        .blk-title{font-size: 18px;}
        .list-box{
            padding: 10px 10px 0;
            ul{
                margin: 0 -10px;
                li{
                    width:50%; padding: 0 10px; margin-bottom: 15px;
                }
            }
        }
    }
}
</style>